import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import {
  getThumbnailTemplateByClipId,
  getThumbnailTemplateGroupedByDate,
  getThumbnailTemplates,
  updateThumbnailTemplateById,
} from "./actions";

export const thumbnailTemplatesEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity?.id,
});

const initialState = thumbnailTemplatesEntityAdapter.getInitialState({
  count: 0,
  modals: {},
  groupByDate: {},
  appliedThumbnail: null,
});

export const thumbnailTemplatesSlice = createSlice({
  name: "thumbnailTemplates",
  initialState: initialState,
  reducers: {
    showCreateThumbnailTemplatesModal: (state, action) => {
      state.modals.createThumbnailTemplatesModal = action.payload;
    },
    showThumbnailTemplateDeleteModal: (state, action) => {
      state.modals.thumbnailTemplateDeleteModal = action.payload;
    },
    showThumbnailTemplateCreateNewComponentModal: (state, action) => {
      state.modals.createNewComponentModal = action.payload;
    },
    showThumbnailTemplateSaveAsPresetModal: (state, action) => {
      state.modals.saveAsPresetModal = action.payload;
    },
    showThumbnailTemplatePresetDeleteModal: (state, action) => {
      state.modals.thumbnailTemplatePresetDeleteModal = action.payload;
    },
    showThumbnailTemplateStaticImageDeleteModal: (state, action) => {
      state.modals.thumbnailTemplateStaticImageDeleteModal = action.payload;
    },
    setAppliedThumbnail: (state, action) => {
      state.appliedThumbnail = action.payload;
    },
    showSaveTemplateModal: (state, action) => {
      state.modals.saveTemplateModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getThumbnailTemplates.fulfilled, (state, action) => {
      if (action.payload.statusCode === 200) {
        const setState = action?.meta?.arg?.setState ?? true;

        if (setState) {
          thumbnailTemplatesEntityAdapter.setAll(state, action.payload.data?.items || {});
          state.count = action.payload?.data?.totalItems;
        }
      } else {
        state.ids = [];
        state.count = 0;
        state.entities = {};
      }
    });
    builder.addCase(getThumbnailTemplateGroupedByDate.fulfilled, (state, action) => {
      if (action.payload.statusCode === 200) {
        const isNewReq = action?.meta?.arg?.payload?.page === 1;

        if (isNewReq) {
          thumbnailTemplatesEntityAdapter.setAll(state, action.payload.entities?.thumbnailTemplates || {});
          state.groupByDate = action.payload.entities?.thumbnailTemplatesGroupedByDate || {};
        } else {
          // for infinite scroll pagination
          thumbnailTemplatesEntityAdapter.setMany(state, action.payload.entities?.thumbnailTemplates || {});
          state.groupByDate = {
            ...state.groupByDate,
            ...(action.payload.entities?.thumbnailTemplatesGroupedByDate || {}),
          };
        }
        state.count = action.payload?.data?.totalItems;
      }
    });
    builder.addCase(updateThumbnailTemplateById.fulfilled, (state, action) => {
      if (action.payload.statusCode === 200 && action?.meta?.arg?.updateState) {
        const id = action?.meta?.arg?.id;
        const { name, tournamentId, category } = action?.payload?.data || {};

        thumbnailTemplatesEntityAdapter.updateOne(state, {
          id,
          changes: {
            name,
            tournamentId,
            category,
          },
        });
      }
    });
    builder.addCase(getThumbnailTemplateByClipId.fulfilled, (state, action) => {
      const isUpdateState = action?.meta?.arg?.isUpdateState || true;

      if (action.payload.statusCode === 200 && isUpdateState) {
        const data = action?.payload?.data?.[0];

        state.appliedThumbnail = data?.thumbnail;
        thumbnailTemplatesEntityAdapter.setOne(state, data?.template);
      }
    });
    builder.addCase(getThumbnailTemplateByClipId.rejected, (state, action) => {
      const isUpdateState = action?.meta?.arg?.isUpdateState || true;

      if (isUpdateState) {
        state.appliedThumbnail = null;
      }
    });
  },
});

export const {
  showCreateThumbnailTemplatesModal,
  showThumbnailTemplateDeleteModal,
  showThumbnailTemplateCreateNewComponentModal,
  showThumbnailTemplateSaveAsPresetModal,
  showThumbnailTemplatePresetDeleteModal,
  showThumbnailTemplateStaticImageDeleteModal,
  setAppliedThumbnail,
  showSaveTemplateModal,
} = thumbnailTemplatesSlice.actions;

export default thumbnailTemplatesSlice.reducer;
